import axios from "axios";
import {
    ACCESS_TOKEN,
    DELETE_DELIVERY_PARTNER_LEDGER_URL,
    GET_DELIVERY_PARTNER_LEDGER_BY_ID,
    GET_DELIVERY_PARTNER_LEDGER_LIST,
    POST_DELIVERY_PARTNER_LEDGER_URL,
    UPDATE_DELIVERY_PARTNER_LEDGER_URL,
    CANCEL_DELIVERY_PARTNER_LEDGER_URL
} from "../helpers/Constant";

export default class DeliveryPartnerLedgerService {

    static getDeliveryPartnerLedgerList(id,params) {
        return axios.get(`${GET_DELIVERY_PARTNER_LEDGER_LIST}/${id}`, {...DeliveryPartnerLedgerService.getAuthHeader(), params});
    }

    static addDeliveryPartnerLedger(id,data) {
        return axios.post(`${POST_DELIVERY_PARTNER_LEDGER_URL}/${id}`, data, DeliveryPartnerLedgerService.getAuthHeader());
    }

    // static getDeliveryPartnerLedgerById(id) {
    //     return axios.get(`${GET_DELIVERY_PARTNER_LEDGER_BY_ID}/${id}`, DeliveryPartnerLedgerService.getAuthHeader());
    // }

    // static editDeliveryPartnerLedger(id, data) {
    //     return axios.put(`${UPDATE_DELIVERY_PARTNER_LEDGER_URL}/${id}`, data, DeliveryPartnerLedgerService.getAuthHeader());
    // }

    static cancelDeliveryPartnerLedger(id) {
        return axios.put(`${CANCEL_DELIVERY_PARTNER_LEDGER_URL}/${id}`,null, DeliveryPartnerLedgerService.getAuthHeader());
    }

    static getAuthHeader = () => {
        const accessToken = localStorage.getItem(ACCESS_TOKEN);
        return {headers: {"x-auth-token": accessToken}};
    }

}